const validate = values => {
	const errors = {}
	if (!values.general_warranty_type) {
		errors.general_warranty_type = 'Este campo es obligatorio'
	}
	return errors
}

export default validate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsGeneralWarrantyForm.js
 **/